import React, { useEffect } from "react";
import HeaderComponent from "components/card/HeaderComponent";
import BarChartBase from "components/charts/BarChartBase";
import { getSixMonthPayrollExpense } from "../../../../../redux/overview/overviewState";
import { useDispatch, useSelector } from "react-redux";


const PayrollOverview = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.overview.getSixMonthPayrollExpense?.data ?? []);

  useEffect(() => {
      dispatch(getSixMonthPayrollExpense());
  }, [dispatch]);

  return (
    <HeaderComponent
      title="Payroll Overview"
      description="Monthly payroll expenses"
    >
      <BarChartBase
        data={data}
        xKey="month"
        height={300}
        yKey="amount"
        useGradient={true}
        textSize={14}
      />
   </HeaderComponent>
  );
};

export default PayrollOverview;
